"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Button_1 = __importDefault(require("../Button"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Permission_1 = __importDefault(require("../Permission"));
exports.default = (function (props) {
    var linkTo = props.linkTo, iconname = props.iconname, name = props.name, viewPermission = props.viewPermission, editPermission = props.editPermission, buttonProps = __rest(props, ["linkTo", "iconname", "name", "viewPermission", "editPermission"]);
    var ButtonCustom = (react_1.default.createElement(Permission_1.default, { viewPermission: viewPermission, editPermission: editPermission },
        react_1.default.createElement(Button_1.default, __assign({ icon: iconname, responsive: true }, buttonProps),
            react_1.default.createElement(FormatText_1.default, { id: name, uppercase: true }))));
    return (react_1.default.createElement(Permission_1.default, { viewPermission: viewPermission, editPermission: editPermission }, linkTo ? react_1.default.createElement(react_router_dom_1.Link, { to: linkTo }, ButtonCustom) : ButtonCustom));
});
